import { UnitListManagerService } from "../../../../services/text-guardian/unit-list";
import { Route, NavigationGuardNext } from "vue-router";

export const UnitListRouteResolver = async function (to: Route, from: Route, next: NavigationGuardNext) {
	const vcsLevelUnits = await UnitListManagerService().getVCSLevelUnits();
	to.meta["vcsLevelUnits"] = vcsLevelUnits;
	next();
};
